import(/* webpackMode: "eager" */ "/codebuild/output/src2716340672/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
